import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { changeActiveSlide } from '../actions'
import parseSlide from './slideParser'
class SlideShow extends Component {

    constructor(props) {
        super(props)
        this.onWheel = this.onWheel.bind(this)
        this.onTouchStart = this.onTouchStart.bind(this)
        this.onTouchEnd = this.onTouchEnd.bind(this)
        this.canScroll = true
    }

    componentDidMount() {
        document.body.addEventListener('touchstart', this.onTouchStart, true)
        document.body.addEventListener('touchend', this.onTouchEnd, true);
    }   

    waitChangeActiveSlide(slide, amount) {

        if(this.canScroll) {

            this.canScroll = false

            setTimeout(() => {
                this.props.changeActiveSlide(slide)
                this.canScroll = true
            }, amount)
        
        }
    
    }

    onTouchStart(event) {
        this.originTouch = event.changedTouches[0] || event.touches[0]
    }

    onTouchEnd(event) {
        this.endTouch = event.changedTouches[0] || event.touches[0]


        if(this.endTouch.screenY - this.originTouch.screenY > 100) {
            this.waitChangeActiveSlide(this.props.activeSlide - 1, 100)
        } else if(this.endTouch.screenY - this.originTouch.screenY < -100) {
            this.waitChangeActiveSlide(this.props.activeSlide + 1, 100)
        }
    }

    onWheel(event) {

        event.preventDefault()
        event.stopPropagation()
        
        const isMac = /Macintosh/.test(navigator.userAgent)
        const amount = isMac ? 1500 : 100

        if(event.deltaY > 0) {
            this.waitChangeActiveSlide(this.props.activeSlide + 1, amount)
        }
        else if(event.deltaY < 0) {
            this.waitChangeActiveSlide(this.props.activeSlide - 1, amount)
        }
        
        

    }

    render() { 

        const nodes = this.props.slides
            .filter((slide, index) => index <= this.props.activeSlide + 1)
            .map((slide, index) => parseSlide(slide, index, this.props.lastSlide, this.props.activeSlide))
        

        return (
            <div onWheel={this.onWheel}>
                { nodes }
            </div>
        )
        
    }
}

SlideShow.propTypes = {
    slides: PropTypes.array.isRequired,
    lastSlide: PropTypes.number.isRequired,
    activeSlide: PropTypes.number.isRequired,
    changeActiveSlide: PropTypes.func.isRequired
}

const mapStateToProps = ({ slides, activeSlide, lastSlide, isMobile }) => ({ slides, activeSlide, lastSlide })
const mapDispatchToProps = dispatch => ({
    changeActiveSlide: slide => dispatch(changeActiveSlide(slide))
})
export default connect(mapStateToProps, mapDispatchToProps)(SlideShow);


// WEBPACK FOOTER //
// ./src/components/SlideShow.js